import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import type { AiActionNodeData, SidebarComponentProps } from '../types'
import { v2validations } from '../config/validation.config'
import { GenericSidebarComponent } from './sidebar.base'
import { Actions } from './ai-agents/ai-actions/actions-v2'

type FormValues = AiActionNodeData['config']

const fields = (nodeVars: string[]): GenericFieldConfig<FormValues> => {
  const validations = v2validations({ nodeVars }).ai_action
  return [
    {
      name: 'name',
      label: 'Name',
      zodValidation: validations.shape.name,
      componentType: 'input',
    },
    {
      name: 'tabs',
      type: 'basic',
      component: ({ form }) => (
        <div className="col-span-2">
          <Actions form={form} nodeVars={nodeVars} />
        </div>
      ),
    },
  ]
}

// NODE_GEN: Update this code, do not commit directly
// Remove this comment after updating the code

export const AiActionSidebarComponent = (props: SidebarComponentProps<AiActionNodeData>) => {
  const { nodeVars } = props
  const formFields = fields(nodeVars)

  return <GenericSidebarComponent fields={formFields} {...props} />
}
